import { useEffect, useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Grid} from '@mui/material'

import { useValidEmail } from '../../hooks/auth/useAuthHooks'
import { Email } from '../../components/auth/authComponents'
import { AuthContext } from '../../contexts/auth/authContext'
import AuthError from '../../components/auth/authError'
import AuthHeader from '../../components/auth/authHeader'
import custom from '../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain, analyticsCta } from '../../services/constants'
import { sendClickAnalytics, sendViewAnalytics } from '../../components/common/util/util'

export default function RequestCode() {
  const auth = useContext(AuthContext)
  const { email, setEmail, emailIsValid } = useValidEmail(auth?.userEmail)
  const [error, setError] = useState('')

  const isNotValid = !emailIsValid || email.length === 0
  
  const navigate = useNavigate()
  
  const sendCodeClicked = async () => {
    try {
      setError('')
      sendClickAnalytics('/requestcode', {
          domain: analyticsDomain.welcome,
          name: analyticsCta.emailValidationReceiveCode,
          metadata: {},
        })
      await auth.requestCode(email)
      navigate('/verifycode')
    } catch (err: any) {
      setError(err.message)
    }
  }
  function handleEnterKey(ev: any) {
    if(ev.key === "Enter" && !isNotValid) {
      sendCodeClicked()
    }
  }
  function handleEmailFormat() {
    if(!emailIsValid) {
      setError('Email format is invalid!')
    } else {
      setError('')
    }
  }

  useEffect(()=>{
    sendViewAnalytics('/requestcode', {
        domain: analyticsDomain.welcome,
        name: analyticsPage.emailVerification
      })
  },[])

  return (
    <AuthHeader
      id="requestcode" 
      title="Forgot password?"
      description="Enter the email address associated with your account and we will send a verification code to your email, that can help us confirm your identity and secure your account."
      >
        <AuthError error={error} />

        <Box width="100%" mt={custom.spacing.sm}>
          <Email emailIsValid={emailIsValid} setEmail={setEmail} 
                  email={email} 
                  onKeyUp={handleEnterKey}
                  onBlur={handleEmailFormat} />
        </Box>

         <Box width="100%" mt={custom.spacing.sm}>
           <Grid container direction="row" justifyContent="center">
              <Button id="sendCode"  fullWidth={true} disabled={isNotValid} 
                color="primary" variant="contained" 
                onKeyUp={handleEnterKey} 
                onClick={sendCodeClicked} >
                Receive Code
              </Button>
            </Grid>
        </Box>
    </AuthHeader>
  )
}
